import { render, staticRenderFns } from "./Workshop_temburong.vue?vue&type=template&id=be960df2&"
import script from "./Workshop_temburong.vue?vue&type=script&lang=js&"
export * from "./Workshop_temburong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports